import PropTypes from 'prop-types';
import React from 'react';

const Step = ({ step, title, description, children }) => (
    <div className="row">
        <div className="column small-12 medium-12 normal-7 large-8">
            <div className="row">
                <div className="column small-12 medium-12 normal-8 large-8">
                    <div className="heading heading--number heading--chameleon">{step}</div>

                    <div className="heading heading--h0 heading--chameleon heading--with-divider">
                        {title}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="column">
                    <div className="paragraph paragraph--root paragraph--offset">{description}</div>
                </div>
            </div>
            <div className="row">
                <div className="column">{children}</div>
            </div>
        </div>
    </div>
);

Step.propTypes = {
    step: PropTypes.number.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Step;
